import { FC } from "react";

import {
  DateTemplate,
  GroupTitleTemplate,
  MultiselectBoundTemplate,
} from "@ryde/controls";

// Labels come from booking.formLabel.<name>; the templates ignore formLabel on an entity page.
export const BulkCloneBookingsForm: FC = () => (
  <>
    <GroupTitleTemplate name="COPY_DATE_RANGE" />
    <DateTemplate name="dateFrom" />
    <DateTemplate name="dateTo" />

    <GroupTitleTemplate name="COPY_ALLOWED_DAYS" />
    <MultiselectBoundTemplate
      name="dayGroup"
      formAttributes={{
        dropItemsSource: "dayGroup",
        dropItemsDisableAdd: true,
      }}
    />
    <MultiselectBoundTemplate
      name="dayType"
      formAttributes={{
        dropItemsSource: "dayType",
        dropItemsDisableAdd: true,
      }}
    />
  </>
);
